import React from 'react';
import { Select } from 'components';
import { useBrandSelectListQuery } from 'api';
import { FMGSelectProps } from 'components/antd/select';

export const BrandSelect: React.FC<FMGSelectProps> = React.memo((props) => {
  const { data = [] } = useBrandSelectListQuery();

  return (
    <Select
      options={data}
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
      {...props}
    />
  );
});
